import { Channels } from '@bandido/shared/constants';

import { EmailItem, NoteItem, WhatsappItem, PhoneItem } from './components';
import { MessageComponent } from './types';

// TODO: Fix the type of MessageFactory
//  @ts-ignore
export const MessageFactory: Record<Channels, MessageComponent> = {
  [Channels.EMAIL]: EmailItem,
  [Channels.NOTES]: NoteItem,
  [Channels.WHATSAPP]: WhatsappItem,
  [Channels.PHONE]: PhoneItem,
} as const;
